export interface FaqItem {
  id: string
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    id: 'receive',
    question: 'What do I receive?',
    answer:
      "You'll receive the complete MATH MADE READY 2026 Edition: three grade-focused math volumes, 27 printable activity pages, answer keys, and the printable Bonus Pack.",
  },
  {
    id: 'grades',
    question: 'What grades is it for?',
    answer: 'It is built for learners in Grades 1 through 5.',
  },
  {
    id: 'physical',
    question: 'Is this a physical product?',
    answer:
      'No. This is a digital printable resource, so nothing is shipped to you.',
  },
  {
    id: 'print',
    question: 'Can I print the activities?',
    answer:
      'Yes. Print any page you need, at home or in the classroom.',
  },
  {
    id: 'audience',
    question: 'Is it for teachers or families?',
    answer:
      'Both. Teachers get ready-to-use practice, and families get clear activities for math at home.',
  },
  {
    id: 'keys',
    question: 'Are answer keys included?',
    answer:
      'Yes. Answer keys are included with the activities where shown in the material.',
  },
  {
    id: 'reuse',
    question: 'Can I use the material more than once?',
    answer:
      'Yes. Print the pages again whenever you need them, within one household or one classroom.',
  },
]
